import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import {
  BadgeStatusInbound,
  BadgeStatusStockTake,
  ReceiveBill,
  WorkOrderStatus
} from '../../atoms/StatusLabel'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const index = ({
  label,
  link,
  back,
  status,
  type,
  labelSub = null,
  stateValue = null,
  labelSubLink = undefined
}) => (
  <>
    <h4 style={headerTitleStyle}>
      {label}{' '}
      <sup style={{ fontSize: '12px', marginLeft: '5px' }}>
        {type === 'ReceiveBill' && <ReceiveBill text={status} />}
        {[
          'BadgeStatusPrList',
          'BadgeStatusPrListInbounds',
          'BadgeStatusPrLists'
        ].includes(type) && <BadgeStatusInbound text={status} type={type} />}
        {type === 'WorkOrderStatus' && <WorkOrderStatus text={status} />}
        {type === 'BadgeStatusStockTake' && (
          <BadgeStatusStockTake text={status} />
        )}
      </sup>
    </h4>
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item sj-item">
          <Link to={link} className="text-decoration-none" state={stateValue}>
            <span className="text-muted opacity-75 fw-bold">{back}</span>
          </Link>
        </li>
        {!labelSubLink && (
          <>
            <li className="px-2 d-flex align-items-center">
              <ChevronRight size={14} className="text-muted opacity-50" />
            </li>
            <li className="breadcrumb-item sj-item active" aria-current="page">
              {!labelSub ? label : labelSub}
            </li>
          </>
        )}
        {labelSubLink && (
          <>
            <li className="px-2 d-flex align-items-center">
              <ChevronRight size={14} className="text-muted opacity-50" />
            </li>
            <li className="breadcrumb-item sj-item">
              <Link
                to={labelSubLink}
                state={stateValue}
                className="text-decoration-none"
              >
                <span className="text-muted opacity-75 fw-bold">{label}</span>
              </Link>
            </li>
            <li className="px-2 d-flex align-items-center">
              <ChevronRight size={14} className="text-muted opacity-50" />
            </li>
            <li
              className="breadcrumb-item sj-item active fw-bold"
              aria-current="page"
            >
              {labelSub}
            </li>
          </>
        )}
      </ol>
    </nav>
  </>
)

export default index
